import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { take, catchError, mergeMap, map } from 'rxjs/operators';
import { FeatureApiService } from '../../services/api/feature-api.service';
import { datadogRum } from '@datadog/browser-rum';
import { FeatureListService } from '../../services/feature-list.service';
import { GlobalNavigationService } from '../../services/global-navigation.service';
import { noDefaultErrorHandler } from '../../services/interceptors';
import { Features } from '../../types/features';

@Injectable({
  providedIn: 'root',
})
export class FeatureListResolverService implements Resolve<Features> {
  constructor(
    private featureApi: FeatureApiService,
    private featureListService: FeatureListService,
    private globalNavigationService: GlobalNavigationService,
  ) {}

  resolve(): Observable<Features> {
    return this.featureApi.getFeatures().pipe(
      take(1),
      noDefaultErrorHandler(),
      catchError((err) => {
        this.globalNavigationService.goHome();
        return throwError(err);
      }),
      mergeMap((features) => {
        if (features) {
          this.featureListService.setAptitudeFeatureList(features);
          const entries = Object.entries(features);
          entries.map(([key, val]) => {
            return datadogRum.addFeatureFlagEvaluation(key, val);
          });

          return of(features);
        } else {
          // id not found or permission denied
          this.globalNavigationService.goHome();
          return throwError('Empty object from rfpApi');
        }
      }),
    );
  }
}
